export const routeColors ={
    '/':{
        bg:'bg-withe',
        nav:''
    },
    '/cursos':{
        bg:'bg-white',
        nav:''
    },
    '/cursos/bkids':{
        bg:'bg-secundario',
        nav:''
    },
    '/cursos/cursos-especializado':{
        bg:'bg-secundario',
        nav:''
    },
    '/cursos/cursos-de-ingles':{
        bg:'bg-secundario',
        nav:''
    },
    '/certificaciones/ielts':{
        bg:'bg-red-500',
        nav:''
    },
    '/certificaciones/toefl':{
        bg:'bg-blue-6',
        nav:''
    },
    '/certificaciones/aptis':{
        bg:'bg-[#acc81e]',
        nav:''
    },
    '/certificaciones/oopt':{
        bg:'bg-blue-200',
        nav:''
    },
};